import { render, staticRenderFns } from "./UnavailableBlockTypeView.vue?vue&type=template&id=55680fd0"
import script from "./UnavailableBlockTypeView.vue?vue&type=script&lang=js"
export * from "./UnavailableBlockTypeView.vue?vue&type=script&lang=js"
import style0 from "./UnavailableBlockTypeView.vue?vue&type=style&index=0&id=55680fd0&prod&lang=css"
import style1 from "./UnavailableBlockTypeView.vue?vue&type=style&index=1&id=55680fd0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports